import refs from "./refs";
import join_game from "./join_game";

export default {
  shouldSeeCard(playerKey, currentPlayer) {
    return playerKey === currentPlayer.playerKey;
  },
  async setTimer(gameId) {
    var snap = await refs.gameConfigs(gameId).once("value");
    await refs.timer(gameId).set(Date.now() + snap.val().timer * 1000);
  },
  async nextPlayer(gameId) {
    var currPlayerSnap = await refs.playerInfo(gameId).once("value");
    var players = [];
    await refs.players(gameId).once("value", (snap) => {
      snap.forEach((playerSnap) => {
        players.push({
          playerKey: playerSnap.ref.key,
          player: playerSnap.val().player,
        });
      });
    });

    var newCounter = currPlayerSnap.val().counter + 1;
    var incrementRound = false;
    if (newCounter == players.length) {
      newCounter = 0;
      incrementRound = true;
    }

    await refs.playerInfo(gameId).update({
      currentPlayer: players[newCounter],
      counter: newCounter,
    });

    if (incrementRound) {
      var snap = await refs.roundCount(gameId).once("value");
      await refs.roundCount(gameId).set(snap.val() + 1);
    }

    await refs.currentTurnWords(gameId).remove();
  },
  async playAgain(gameId) {
    await refs.state(gameId).set("recreating");
    var players = await join_game.getPlayers(gameId);
    await refs
      .playerInfo(gameId)
      .update({ currentPlayer: players[0], counter: 0 });
    await refs.game(gameId).update({ roundCount: 1 });
    await refs.players(gameId).once("value", snapshot =>{
      snapshot.forEach(p => p.child("score").ref.set(0))
    })
    await refs.state(gameId).set("started");
  },
  async taboo(gameId, word, playerKey) {
    await this.pushToCurrentTurn(gameId, word, "taboo");
    await this.updateScore(gameId, playerKey, -1);
    await this.nextCard(gameId);
  },
  async pass(gameId, word, playerKey) {
    await this.pushToCurrentTurn(gameId, word, "pass");
    await this.updateScore(gameId, playerKey, 0);
    await this.nextCard(gameId);
  },
  async correct(gameId, word, playerKey) {
    await this.pushToCurrentTurn(gameId, word, "correct");
    await this.updateScore(gameId, playerKey, 1);
    await this.nextCard(gameId);
  },
  async updateScore(gameId, playerKey, interval) {
    if (interval == 0) {
      return;
    }
    var snap = await refs.player(gameId, playerKey).once("value");
    await refs
      .player(gameId, playerKey)
      .update({ score: snap.val().score + interval });
  },
  async pushToCurrentTurn(gameId, word, status) {
    await refs.currentTurnWords(gameId).push({ word: word, status: status });
  },
  async nextCard(gameId) {
    var snap = await refs.wordsInfo(gameId).once("value");
    var newCounter = snap.val().counter + 1;
    var newWords = snap.val().words;
    if (newCounter === snap.val().words.length) {
      newCounter = 0;
      newWords = this.shuffle(snap.val().words);
    }
    var newCurrCard = newWords[newCounter];
    await refs.wordsInfo(gameId).update({
      counter: newCounter,
      currentCard: newCurrCard,
      words: newWords,
    });
  },
  shuffle(deck) {
    // from https://javascript.info/task/shuffle
    for (let i = deck.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1)); // random index from 0 to i
      [deck[i], deck[j]] = [deck[j], deck[i]];
    }
    return deck;
  },
};
